/*
 * Purpose: Unread mission notification counts — receipts + plan updates
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { create } from 'zustand';

interface MissionNotificationStore {
  lastSeenReceiptSeq: number;
  latestReceiptSeq: number;
  unreadReceipts: number;
  planUpdatedAt: number | null;
  onNewReceipt: (seq: number) => void;
  onPlanUpdated: () => void;
  markReceiptsSeen: () => void;
  markPlanSeen: () => void;
  reset: () => void;
}

export const useMissionNotificationStore = create<MissionNotificationStore>((set, get) => ({
  lastSeenReceiptSeq: 0,
  latestReceiptSeq: 0,
  unreadReceipts: 0,
  planUpdatedAt: null,

  onNewReceipt: (seq) => {
    const { lastSeenReceiptSeq } = get();
    set({
      latestReceiptSeq: seq,
      unreadReceipts: Math.max(0, seq - lastSeenReceiptSeq),
    });
  },

  onPlanUpdated: () => {
    set({ planUpdatedAt: Date.now() });
  },

  markReceiptsSeen: () => {
    const { latestReceiptSeq } = get();
    set({
      lastSeenReceiptSeq: latestReceiptSeq,
      unreadReceipts: 0,
    });
  },

  markPlanSeen: () => {
    set({ planUpdatedAt: null });
  },

  reset: () => {
    set({
      lastSeenReceiptSeq: 0,
      latestReceiptSeq: 0,
      unreadReceipts: 0,
      planUpdatedAt: null,
    });
  },
}));
